module.exports = __webpack_public_path__ + "static/media/04_avatar_animal.0e24d8f7.png";